import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/api/settings";
import { DEFAULT_VOLUME_UNIT } from "@/lib/units";

/**
 * Returns the tenant's configured volume unit label (e.g. "m3", "ft3").
 * Falls back to the backend default ("m3") while the settings are loading or
 * unavailable.
 *
 * Mirrors `useCostUnit` exactly, including the shared `["settings"]` query key
 * and 5-minute staleTime, so a screen reading both units issues one request.
 *
 * The value is a LABEL only — see `formatVolume` in `@/lib/format`. Nothing
 * converts the underlying figure.
 */
export function useVolumeUnit(): string {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: getSettings,
    staleTime: 5 * 60 * 1000,
  });
  return data?.volume_unit || DEFAULT_VOLUME_UNIT;
}
